/**
 * Mono wait time, coloring in as it ages — matches the confirmed AsIs mockup's thresholds.
 * Used by the Dashboard's review queue.
 */
export function WaitTime({ hours }: { hours: number }) {
	const late = hours >= 48
	const warn = hours >= 24 && !late
	const text =
		hours < 1
			? 'just now'
			: hours < 24
				? `${Math.floor(hours)}h`
				: `${Math.floor(hours / 24)}d ${Math.floor(hours % 24)}h`
	return (
		<span
			className={`whitespace-nowrap font-mono text-xs ${
				late ? 'font-semibold text-ds-danger-strong' : warn ? 'text-ds-warning' : 'text-ds-text-subtle'
			}`}
		>
			{text}
		</span>
	)
}
